import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { API_URL } from '../config/api';
import Loading from '../components/Loading';

const getVideoFullUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  const normalized = url.startsWith('/') ? url : `/${url}`;
  if (normalized.startsWith('/uploads/')) return `${API_URL}/api${normalized}`;
  return `${API_URL}${normalized}`;
};

const SharedPlan = () => {
  const { token } = useParams();
  const [plan, setPlan] = useState(null);
  const [imagesMap, setImagesMap] = useState({});
  const [clientData, setClientData] = useState(null);
  const [videosMap, setVideosMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSharedPlan = async () => {
      try {
        const response = await fetch(`${API_URL}/api/client/shared-plans/${token}`);
        if (response.ok) {
          const data = await response.json();
          const fullPlan = {
             ...data.plan.scheda_json,
             nome_scheda: data.plan.nome,
             durata_settimane: data.plan.durata_settimane,
             frequenza_settimanale: data.plan.frequenza_settimanale,
             descrizione: data.plan.scheda_json.descrizione || data.plan.obiettivi,
             giorni: data.plan.scheda_json.giorni || []
          };
          setPlan(fullPlan);
          setImagesMap(data.imagesMap || {});
          setClientData(data.clientData || null);
          setVideosMap(data.videosMap || {});
        } else {
          let message = 'Scheda non trovata o link scaduto.';
          try {
            const data = await response.json();
            if (response.status === 403 && data.error) {
              message = 'Scheda scaduta.';
            } else if (response.status === 401 && data.error) {
              message = 'Link scaduto o non valido.';
            } else if (response.status === 404 && data.error) {
              message = 'Scheda non trovata o rimossa.';
            }
          } catch {
            // keep default message
          }
          setError(message);
        }
      } catch (err) {
        setError('Errore di connessione.');
      } finally {
        setLoading(false);
      }
    };

    fetchSharedPlan();
  }, [token]);

  if (loading) return <Loading />;
  if (error) return <div style={{ padding: '40px', textAlign: 'center', color: '#fff', backgroundColor: '#1a1a1a', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><h2>{error}</h2></div>;
  if (!plan) return null;

  const hasBodyComp = clientData?.bodyComposition;
  const plicheEntries = clientData?.pliche
    ? [
        { key: 'pettorale', label: 'Pettorale' },
        { key: 'tricipite', label: 'Tricipite' },
        { key: 'ascellare', label: 'Ascellare' },
        { key: 'scapolare', label: 'Sottoscapolare' },
        { key: 'soprailiaca', label: 'Soprailiaca' },
        { key: 'addominale', label: 'Addominale' },
        { key: 'coscia', label: 'Coscia' },
        { key: 'bicipite', label: 'Bicipite' },
      ].filter(item => clientData.pliche[item.key] !== null)
    : [];
  const circEntries = clientData?.circonferenze
    ? [
        { key: 'spalle', label: 'Spalle' },
        { key: 'petto', label: 'Petto' },
        { key: 'braccio', label: 'Braccio' },
        { key: 'vita', label: 'Vita' },
        { key: 'fianchi', label: 'Fianchi' },
        { key: 'coscia', label: 'Coscia' },
        { key: 'polpaccio', label: 'Polpaccio' },
      ].filter(item => clientData.circonferenze[item.key] !== null)
    : [];

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto', fontFamily: 'sans-serif', backgroundColor: '#f4f4f4', minHeight: '100vh', color: '#333' }}>
      
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '30px', borderBottom: '2px solid #ebcd61', paddingBottom: '20px' }}>
        <h1 style={{ color: '#222', margin: '0 0 10px 0', letterSpacing: '1px' }}>KINESIS FIT CENTER</h1>
        <h2 style={{ color: '#555', margin: 0, fontSize: '24px' }}>{plan.nome_scheda}</h2>
        <div style={{ marginTop: '15px', color: '#666' }}>
            <span>Durata: <strong>{plan.durata_settimane} settimane</strong></span>
            <span style={{ margin: '0 15px' }}>|</span>
            <span>Frequenza: <strong>{plan.frequenza_settimanale}x/settimana</strong></span>
        </div>
      </div>

      {plan.descrizione && (
          <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#ebcd61', textTransform: 'uppercase', letterSpacing: '1px' }}>Descrizione</h3>
              <p style={{ margin: 0, lineHeight: '1.6', color: '#444' }}>{plan.descrizione}</p>
          </div>
      )}

      {/* Dati Misurazione Cliente */}
      {(hasBodyComp || plicheEntries.length > 0 || circEntries.length > 0) && (
        <div style={{ marginBottom: '30px', padding: '24px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', borderLeft: '4px solid #ebcd61' }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#ebcd61', textTransform: 'uppercase', letterSpacing: '1px' }}>I Tuoi Dati</h3>

          {hasBodyComp && (
            <div style={{ marginBottom: (plicheEntries.length > 0 || circEntries.length > 0) ? '20px' : 0 }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px', marginBottom: '8px' }}>
                <div style={{ textAlign: 'center', padding: '12px', backgroundColor: '#f9f9f9', borderRadius: '6px' }}>
                  <div style={{ fontSize: '11px', color: '#999', textTransform: 'uppercase', marginBottom: '4px' }}>% Grasso</div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#ebcd61' }}>{clientData.bodyComposition.percentuale_grasso}%</div>
                </div>
                <div style={{ textAlign: 'center', padding: '12px', backgroundColor: '#f9f9f9', borderRadius: '6px' }}>
                  <div style={{ fontSize: '11px', color: '#999', textTransform: 'uppercase', marginBottom: '4px' }}>Massa Grassa</div>
                  <div style={{ fontSize: '20px', fontWeight: '600', color: '#555' }}>{clientData.bodyComposition.massa_grassa_kg} kg</div>
                </div>
                <div style={{ textAlign: 'center', padding: '12px', backgroundColor: '#f9f9f9', borderRadius: '6px' }}>
                  <div style={{ fontSize: '11px', color: '#999', textTransform: 'uppercase', marginBottom: '4px' }}>Massa Magra</div>
                  <div style={{ fontSize: '20px', fontWeight: '600', color: '#555' }}>{clientData.bodyComposition.massa_magra_kg} kg</div>
                </div>
                {clientData.peso && (
                  <div style={{ textAlign: 'center', padding: '12px', backgroundColor: '#f9f9f9', borderRadius: '6px' }}>
                    <div style={{ fontSize: '11px', color: '#999', textTransform: 'uppercase', marginBottom: '4px' }}>Peso</div>
                    <div style={{ fontSize: '20px', fontWeight: '600', color: '#555' }}>{clientData.peso} kg</div>
                  </div>
                )}
              </div>
              {clientData.measurementDate && (
                <div style={{ fontSize: '11px', color: '#aaa' }}>
                  Rilevazione del {new Date(clientData.measurementDate).toLocaleDateString('it-IT')}
                </div>
              )}
            </div>
          )}

          {plicheEntries.length > 0 && (
            <div style={{ marginBottom: circEntries.length > 0 ? '20px' : 0 }}>
              <div style={{ fontSize: '12px', color: '#999', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px', fontWeight: '600' }}>Plicometria</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '8px' }}>
                {plicheEntries.map(item => (
                  <div key={item.key} style={{ textAlign: 'center', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '6px' }}>
                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px' }}>{item.label}</div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#555' }}>{clientData.pliche[item.key]} mm</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {circEntries.length > 0 && (
            <div>
              <div style={{ fontSize: '12px', color: '#999', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px', fontWeight: '600' }}>Circonferenze</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '8px' }}>
                {circEntries.map(item => (
                  <div key={item.key} style={{ textAlign: 'center', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '6px' }}>
                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px' }}>{item.label}</div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#ebcd61' }}>{clientData.circonferenze[item.key]} cm</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Giorni */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
        {plan.giorni.map((giorno, idx) => (
            <div key={idx} style={{ backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ backgroundColor: '#222', color: '#ebcd61', padding: '15px 20px', fontWeight: 'bold', fontSize: '18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{giorno.nome_giorno || `Giorno ${idx + 1}`}</span>
                    <span style={{ fontSize: '12px', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '1px' }}>Sessione {idx + 1}</span>
                </div>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '600px' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#ebcd61', color: '#222', textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.5px' }}>
                                <th style={{ padding: '12px 15px', textAlign: 'left', width: '35%' }}>Esercizio</th>
                                <th style={{ padding: '12px', textAlign: 'center' }}>Serie</th>
                                <th style={{ padding: '12px', textAlign: 'center' }}>Reps</th>
                                <th style={{ padding: '12px', textAlign: 'center' }}>Rec.</th>
                                <th style={{ padding: '12px', textAlign: 'left', width: '25%' }}>Note / Tecnica</th>
                            </tr>
                        </thead>
                        <tbody>
                            {giorno.esercizi.map((ex, i) => (
                                <tr key={i} style={{ borderBottom: i === giorno.esercizi.length - 1 && !(giorno.esercizi_bonus?.length) ? 'none' : '1px solid #f0f0f0' }}>
                                    <td style={{ padding: '15px', color: '#222' }}>
                                        <div style={{ fontWeight: '600', fontSize: '15px' }}>{ex.nome}</div>
                                        {ex.macchinario_target && (
                                            <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                                                {ex.macchinario_target}
                                            </div>
                                        )}
                                        {imagesMap[ex.macchinario_target] && (
                                            <div style={{ marginTop: '8px' }}>
                                                <img 
                                                    src={`${API_URL}${imagesMap[ex.macchinario_target]}`} 
                                                    alt={ex.macchinario_target}
                                                    style={{ width: '100px', height: '100px', objectFit: 'contain', borderRadius: '6px', border: '1px solid #eee', backgroundColor: '#fff' }} 
                                                />
                                            </div>
                                        )}
                                        {videosMap[ex.nome] && (
                                            <div style={{ marginTop: '8px', maxWidth: '280px' }}>
                                                <video
                                                    src={getVideoFullUrl(videosMap[ex.nome])}
                                                    controls
                                                    preload="metadata"
                                                    style={{ width: '100%', borderRadius: '6px', border: '1px solid #eee' }}
                                                />
                                            </div>
                                        )}
                                    </td>
                                    <td style={{ padding: '15px', textAlign: 'center', color: '#555' }}>{ex.serie}</td>
                                    <td style={{ padding: '15px', textAlign: 'center', color: '#555' }}>{ex.ripetizioni}</td>
                                    <td style={{ padding: '15px', textAlign: 'center', color: '#555' }}>{ex.recupero}</td>
                                    <td style={{ padding: '15px', fontSize: '13px', color: '#666', lineHeight: '1.4' }}>
                                        {ex.tecnica_intensita && <div style={{ fontWeight: 'bold', marginBottom: '4px', color: '#d32f2f', fontSize: '11px', textTransform: 'uppercase' }}>{ex.tecnica_intensita}</div>}
                                        {ex.note}
                                    </td>
                                </tr>
                            ))}
                            {giorno.esercizi_bonus && giorno.esercizi_bonus.length > 0 && (
                              <>
                                <tr>
                                  <td colSpan="5" style={{ padding: '10px 15px', backgroundColor: '#fef8e7', color: '#e8a838', fontWeight: '600', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    Esercizi Bonus
                                  </td>
                                </tr>
                                {giorno.esercizi_bonus.map((ex, i) => (
                                  <tr key={`bonus-${i}`} style={{ borderBottom: i === giorno.esercizi_bonus.length - 1 ? 'none' : '1px solid #f0f0f0', backgroundColor: '#fffdf5' }}>
                                    <td style={{ padding: '15px', color: '#222' }}>
                                      <div style={{ fontWeight: '600', fontSize: '15px' }}>{ex.nome}</div>
                                      {ex.macchinario_target && (
                                        <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>{ex.macchinario_target}</div>
                                      )}
                                      {imagesMap[ex.macchinario_target] && (
                                        <div style={{ marginTop: '8px' }}>
                                          <img src={`${API_URL}${imagesMap[ex.macchinario_target]}`} alt={ex.macchinario_target}
                                            style={{ width: '100px', height: '100px', objectFit: 'contain', borderRadius: '6px', border: '1px solid #eee', backgroundColor: '#fff' }} />
                                        </div>
                                      )}
                                      {videosMap[ex.nome] && (
                                        <div style={{ marginTop: '8px', maxWidth: '280px' }}>
                                          <video src={getVideoFullUrl(videosMap[ex.nome])} controls preload="metadata"
                                            style={{ width: '100%', borderRadius: '6px', border: '1px solid #eee' }} />
                                        </div>
                                      )}
                                    </td>
                                    <td style={{ padding: '15px', textAlign: 'center', color: '#555' }}>{ex.serie}</td>
                                    <td style={{ padding: '15px', textAlign: 'center', color: '#555' }}>{ex.ripetizioni}</td>
                                    <td style={{ padding: '15px', textAlign: 'center', color: '#555' }}>{ex.recupero}</td>
                                    <td style={{ padding: '15px', fontSize: '13px', color: '#666', lineHeight: '1.4' }}>
                                      {ex.tecnica_intensita && <div style={{ fontWeight: 'bold', marginBottom: '4px', color: '#d32f2f', fontSize: '11px', textTransform: 'uppercase' }}>{ex.tecnica_intensita}</div>}
                                      {ex.note}
                                    </td>
                                  </tr>
                                ))}
                              </>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        ))}
      </div>

      {/* Footer Consigli */}
      {plan.consigli_trainer && plan.consigli_trainer.length > 0 && (
          <div style={{ marginTop: '40px', padding: '25px', backgroundColor: '#fff', borderLeft: '5px solid #ebcd61', borderRadius: '4px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
              <h3 style={{ margin: '0 0 15px 0', color: '#222', fontSize: '18px' }}>Consigli del Trainer</h3>
              <ul style={{ margin: 0, paddingLeft: '20px' }}>
                  {plan.consigli_trainer.map((tip, i) => (
                      <li key={i} style={{ marginBottom: '10px', lineHeight: '1.6', color: '#444' }}>{tip}</li>
                  ))}
              </ul>
          </div>
      )}
      
      <div style={{ marginTop: '60px', textAlign: 'center', color: '#aaa', fontSize: '12px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
          &copy; {new Date().getFullYear()} Kinesis Fit Center. Tutti i diritti riservati.
      </div>
    </div>
  );
};

export default SharedPlan;
